export const PAGE_STATUS = {
  active: 'active',
  inactive: 'inactive',
} as const;

export interface Page {
  external_link: string | null;
  id: number;
  open_in_new_window: boolean;
  redirect: boolean;
  remote_id: string;
  show_in_footer: boolean;
  show_in_rules: boolean;
  site_section: string | null;
  slug: string;
  status: keyof typeof PAGE_STATUS;
  title: string;
  unique_content: null | 'agreement';
}
